import APIClient from './index';
import _ from 'lodash';

export const getAllJobs = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('JobOpenings')
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, 'data.error')));
  });
};

/**
 * @param {Object} data
 * @param {string} data.title - Title of job
 * @param {string} data.summary - Summary of job
 * @param {string} data.department - Department of job
 * @param {string} data.responsibilities - Responsibilities of job separated by \n\n
 * @param {string} data.qualifications - Qualifications of job separated by \n\n
 * @param {boolean} data.stillAvailable - Whether or not the job is still available
 */
export const createJob = data => {
  return new Promise((resolve, reject) => {
    APIClient.post('JobOpenings', data)
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, 'data.error')));
  });
};

/**
 * @param {Object} updates
 * @param {string} updates.title - Title of job
 * @param {string} updates.summary - Summary of job
 * @param {string} updates.department - Department of job
 * @param {string} updates.responsibilities - Responsibilities of job separated by \n\n
 * @param {string} updates.qualifications - Qualifications of job separated by \n\n
 * @param {boolean} updates.stillAvailable - Whether or not the job is still available
 */
export const updateJob = (Job_id, updates) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`JobOpenings/${Job_id}`, updates)
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, 'data.error')));
  });
};

/**
 * @param {string} Job_id
 */
export const deleteJob = Job_id => {
  return new Promise((resolve, reject) => {
    APIClient.delete(`JobOpenings/${Job_id}`)
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, 'data.error')));
  });
};

/**
 * @param {Object} data
 * @param {string} data.name - Name of applicant
 * @param {string} data.email - email of applicant
 * @param {File} data.resume - resume file of applicant
 * @param {File} data.coverLetter - coverLetter file of applicant
 * @param {string} data.linkedin - linkedin url of applicant
 * @param {string} data.website - website url of applicant
 * @param {string} data.github - github url of applicant
 */
export const submitJobApplication = data => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/JobApplication`, data)
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, ['data', 'error'])));
  });
};
